import React from 'react';

import { useTranslation } from 'react-i18next';

import { type SocialGroup } from '@app/gen';

import { Badge } from './Badge';
import { PrivateBadge } from './PrivateBadge';

import { BadgeContainer } from './styles';

type BadgesProps = Partial<Pick<SocialGroup, 'privacy'>> & {
    isFollowing?: boolean;
    hasMembership?: boolean;
    isOwner?: boolean;
};

export const Badges = ({ privacy, isFollowing, hasMembership, isOwner }: BadgesProps) => {
    const { t } = useTranslation(['groups']);
    let text: string | undefined;
    let variant: 'blue' | 'grey' | 'flat' = 'flat';

    if (isOwner) {
        text = t('groups_owner');
        variant = 'blue';
    } else if (hasMembership) {
        text = t('groups_member');
        variant = 'grey';
    } else if (isFollowing) {
        text = t('groups_following');
    }

    const isPrivate = privacy === 'Private';

    if (text) {
        return (
            <BadgeContainer>
                {text && <Badge text={text} variant={variant} />}
                {isPrivate && <PrivateBadge />}
            </BadgeContainer>
        );
    }

    return null;
};
